import React, { useEffect } from "react";
import FaqTwo from "../../components/universal-components/FaqTwo";

const FaqPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      <FaqTwo />
    </>
  );
};

export default FaqPage;
